import { useCollections } from "@/context";
import { useState, useEffect, useRef } from "react";
import { RiArrowRightDoubleFill} from "react-icons/ri";
import { motion } from "framer-motion";
import { excludedIds } from ".";
import { CollectionListing } from "@/context/CollectionsContext";
import { useNavigate } from "react-router-dom";
import { RiMenu3Line } from "react-icons/ri";

export const NavHeaderDesktop = () => {
  const navigate = useNavigate();
  const { collections } = useCollections();
  const [menuOpen, setMenuOpen] = useState(false);
  const [collectionsFiltered, setCollectionsFiltered] = useState<CollectionListing[]>([]);
  const listRef = useRef<HTMLUListElement>(null);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const handleClick = (product: string, id: number) => {
    navigate(`/collection/${product}/${id}`);
  };

  useEffect(() => {
    if (collections) {
      const filteredCollections = collections.filter(
        (collection) => !excludedIds.includes(collection.id)
      );
      setCollectionsFiltered(filteredCollections);
    }
  }, [collections]);

  return (
    <div className="relative">
      {/* Botão para abrir/fechar o menu */}
                    <button
                onClick={toggleMenu}
                className="fixed top-6 right-0 transform -translate-x-1/2 bg-gray-800 text-red-500 p-2 rounded-l-md z-50"
              >
                {menuOpen ? <RiArrowRightDoubleFill size={24} /> : <RiMenu3Line size={24} />}
              </button>

   {/* Menu lateral */}
<motion.div
  className="fixed top-10 right-0  h-full w-64 bg-white shadow-lg flex flex-col p-4 z-40"
  initial={{ x: "100%" }}
  animate={{ x: menuOpen ? "0%" : "100%" }}
  transition={{ duration: 0.5, ease: "easeInOut" }}
>
<motion.ul
  ref={listRef}
  className="flex bg-black flex-col gap-y-5 mt-10 pl-6 border-2 border-red-500"
>
  {collectionsFiltered.length > 0 &&
    collectionsFiltered.map((collection) => (
      <li
        key={collection.id}
        className="text-sm text-marfim cursor-pointer hover:text-red-500"
        onClick={() => handleClick(collection.title, collection.id)}
      >
        {collection.title}
      </li>
    ))}
</motion.ul>
</motion.div>
    </div>
  );
};
